<script setup lang="ts">
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@laam/ui/base';
import { PhCoatHanger } from '@phosphor-icons/vue';

interface ProductDescriptionProps {
	description: string;
	productType: string;
	brandName: string;
}

const { $eventClient } = useNuxtApp();

const handleDescriptionClick = () => {
	$eventClient.sendEvent('product-description-click', {
		product_type: props.productType,
		brand_name: props.brandName,
	});
};

const props = defineProps<ProductDescriptionProps>();
</script>

<template>
	<div class="pdp__description gap-xl flex flex-col relative">
		<Accordion
			type="single"
			class="product-description--accordion flex-1 max-h-[350px] overflow-y-auto"
			collapsible
			default-value="description"
		>
			<AccordionItem
				value="description"
				class="rounded-medium border border-gray-300 border-solid"
			>
				<AccordionTrigger
					class="p-xl w-full !border-none"
					@click="handleDescriptionClick"
				>
					<div class="gap-md flex items-center">
						<PhCoatHanger class="h-5xl w-5xl text-gray-800" />

						<span class="text-md font-semibold text-gray-800">Description</span>
					</div>
				</AccordionTrigger>

				<AccordionContent class="p-xl lg:p-3xl pt-none gap-xl flex flex-col">
					<!-- <div
					v-if="props.externalProductId !== null"
					class="external-product-id gap-xl flex flex-col"
				>
					<div class="h-[1px] w-full bg-gray-300" />

					<Button
						variant="tertiary"
						class="p-md rounded-small flex justify-between text-sm bg-gray-100"
						@click="copyId(props.externalProductId)"
					>
						<div class="gap-xxs flex">
							<span class="text-sm font-medium">Item ID:</span>
							<span class="desc_id text-sm font-medium">{{
								props.externalProductId
							}}</span>
						</div>

						<span class="font-semibold text-blue-700"> Copy </span>
					</Button>
				</div> -->
					<!-- eslint-disable vue/no-v-html -->
					<span
						class="text-sm text-gray-600 description-text"
						v-html="props.description"
					/>
					<!--eslint-enable-->
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	</div>
</template>

<style scope>
.description-text {
	white-space: pre-line;
}
</style>
